import { useEffect, useState } from "react";

const MIN_DISPLAY_MS = 900;
const FADE_MS = 500;

export type WarmupPhase = "loading" | "fading" | "ready";

export default function useWarmup() {
  const [phase, setPhase] = useState<WarmupPhase>("loading");

  useEffect(() => {
    const start = Date.now();

    async function warmup() {
      try {
        await fetch(import.meta.env.VITE_ADMIN_API_URL + "/warmup", {
          method: "post"
        });
      } catch {
        // Warmup is best-effort
      }

      const elapsed = Date.now() - start;
      const remaining = Math.max(0, MIN_DISPLAY_MS - elapsed);

      // Ensure splash shows for at least MIN_DISPLAY_MS so it doesn't flash
      setTimeout(() => {
        setPhase("fading");
        // After fade-out completes, mark ready
        setTimeout(() => setPhase("ready"), FADE_MS);
      }, remaining);
    }
    warmup();
  }, []);

  return { phase };
}
